import * as constants from './constants';
import { LIST_ORDER } from '../../attrs/sorter_default_values';

const loadMachineMetricsAlarmHistory = (
  params = {
    page: 1,
    limit: 5,
    sort: 'time',
    order: LIST_ORDER,
    machine_ids: '',
    from: '',
    to: ''
  }
) => ({
  type: constants.LOAD_MACHINE_METRICS_ALARM_HISTORY,
  ...params
});

export { loadMachineMetricsAlarmHistory };
